import React, { useState } from 'react';
import { Icon } from '@iconify/react';

function RTYGIA() {
    const [showApplicationForm, setShowApplicationForm] = useState(false);

    const handleApplicationSubmit = (e) => {
        e.preventDefault();
        console.log('Application submitted');
        // Handle application submission
    };

    return (
        <div className="rtygia-page">
            {/* Hero Section */}
            <section className="program-hero rtygia-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <div className="program-badge">
                                <Icon icon="mdi:certificate" />
                                <span>Signature White Label Initiative</span>
                            </div>
                            <h1 className="program-hero-title animate-slide-up">
                                Route Tracers YSN Geospatial Innovation Award
                            </h1>
                            <p className="program-hero-subtitle animate-slide-up delay-1">
                                Recognizing and supporting young innovators leveraging geospatial technology
                                for health and community development
                            </p>
                            {/*
              <div className="program-hero-buttons animate-slide-up delay-2">
                <button 
                  className="btn btn-apply" 
                  onClick={() => setShowApplicationForm(!showApplicationForm)}
                >
                  <Icon icon="mdi:application" className="me-2" />
                  Apply for Award
                </button>
                <button className="btn btn-donate-program">
                  <Icon icon="mdi:hand-heart" className="me-2" />
                  Support RTYGIA
                </button>
              </div>
              */}
                        </div>
                        <div className="col-lg-5">
                            <div className="award-badge-display animate-fade-in delay-2">
                                <div className="award-seal">
                                    <Icon icon="mdi:trophy" className="award-icon" />
                                    <div className="award-text">
                                        <strong>RTYGIA</strong>
                                        <span>2025-2031</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* About Award */}
            <section className="award-about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="section-header">
                                <span className="section-label">About the Award</span>
                                <h2 className="section-title">Pioneering Geospatial Innovation</h2>
                            </div>
                            <p className="about-text">
                                The Route Tracers YSN Geospatial Innovation Award is a 5-year endowed initiative designed to identify, support, and scale innovative, scalable, and wide-ranging ideas in the field of surveying, geographic information systems, remote sensing, and environmental management, developed by young surveyors (aged 35 years and below) who are members of the Young Surveyors Network, Nigeria.
                                For the next five years (2026-2031), one member of the Young Surveyors Network (YSN) will receive a $1,000 award each year to support the development of an innovative project.
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <div className="award-highlights">
                                <h4>Award Package</h4>
                                <div className="highlight-item">
                                    <Icon icon="mdi:cash" />
                                    <div>
                                        <strong>$5,000 ($1,000/yr)</strong>
                                        <span className='ms-2'>Total Fund</span>
                                    </div>
                                </div>
                                <div className="highlight-item">
                                    <Icon icon="mdi:clock" />
                                    <div>
                                        <strong>5 years</strong>
                                        <span className='ms-2'>Duration</span>
                                    </div>
                                </div>
                                <div className="highlight-item">
                                    <Icon icon="mdi:account-school" />
                                    <div>
                                        <strong>Mentorship</strong>
                                        <span className='ms-2'>for Awardees</span>
                                    </div>
                                </div>
                                <div className="highlight-item">
                                    <Icon icon="mdi:earth" />
                                    <div>
                                        <strong>Global</strong>
                                        <span className='ms-2'>Network Access</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Eligibility Criteria */}
            <section className="eligibility-section">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Who Can Apply</span>
                        <h2 className="section-title">Selection Criteria</h2>
                    </div>

                    <div className="row g-4 ">
                        <div className="col-lg-3 col-md-6">
                            <div className="criteria-card">
                                <h4 className="section-title">25%</h4>
                                <h4>Innovation</h4>
                                <p>The extent to which the idea presents a new or creative approach to solving an existing challenge within the field of surveying, geographic information systems, remote sensing, and environmental management or related disciplines.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="criteria-card">
                                <h4 className="section-title">35%</h4>
                                <h4>Scalability </h4>
                                <p>The practicality of implementing the idea and its potential to be sustained long term, expanded, or even replicated across other settings.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="criteria-card">
                                <h4 className="section-title">30%</h4>
                                <h4>Impact</h4>
                                <p>The potential of the idea to be highly impactful to the YSN, or the overall surveying community, organizations, the government, or society at large.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="criteria-card">
                                <h4 className="section-title">10%</h4>
                                <h4>Presentation</h4>
                                <p>The overall organization, coherence, and persuasiveness of the submission, including the ability to communicate the idea effectively and professionally.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Application Process */}
            <section className="application-process">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Award Cycle</span>
                        <h2 className="section-title">Yearly Award Cycle</h2>
                    </div>

                    <div className="process-timeline">
                        <div className="process-step">
                            <div className="step-marker">1</div>
                            <div className="step-content">
                                <h4>Call for Proposals</h4>
                                <p>HSCF issues an open call to young surveyors (≤35 yrs).</p>
                                <span className="step-date">January - March</span>
                            </div>
                        </div>
                        <div className="process-step">
                            <div className="step-marker">2</div>
                            <div className="step-content">
                                <h4>Submission Review</h4>
                                <p>Judges conduct a blinded evaluation.</p>
                                <span className="step-date">April</span>
                            </div>
                        </div>
                        <div className="process-step">
                            <div className="step-marker">3</div>
                            <div className="step-content">
                                <h4>Selection</h4>
                                <p>YSN Exco selects the final awardee from the top 3 recommendations.</p>
                                <span className="step-date">May</span>
                            </div>
                        </div>
                        <div className="process-step">
                            <div className="step-marker">4</div>
                            <div className="step-content">
                                <h4>Announcement</h4>
                                <p>Winner announced via listserv or newsletter</p>
                                <span className="step-date">June</span>
                            </div>
                        </div>
                        <div className="process-step">
                            <div className="step-marker">5</div>
                            <div className="step-content">
                                <h4>Implementation & Support</h4>
                                <p>Awardee is connected with the sponsor organization (or other available host company) for the implementation of their innovative idea</p>
                                <span className="step-date">July - December</span>
                            </div>
                        </div>
                        <div className="process-step">
                            <div className="step-marker">5</div>
                            <div className="step-content">
                                <h4>Presentation at the annual YSN conference</h4>
                                <p>Awardee is recognized at the annual YSN conference and also presents progress on their work.</p>
                                <span className="step-date">November</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Past Winners */}
            {/*
      <section className="past-winners">
        <div className="container">
          <div className="section-header text-center">
            <span className="section-label">Excellence Recognized</span>
            <h2 className="section-title">Past Award Recipients</h2>
          </div>

          <div className="row g-4">
            <div className="col-lg-4">
              <div className="winner-card">
                <div className="winner-year">2024</div>
                <h4>Dr. Chioma Nwosu</h4>
                <p className="winner-project">
                  "Mapping Malaria Hotspots in Rural Nigeria Using Satellite Imagery and AI"
                </p>
                <div className="winner-impact">
                  <Icon icon="mdi:check-circle" />
                  <span>Reduced malaria cases by 40% in target areas</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="winner-card">
                <div className="winner-year">2023</div>
                <h4>Emmanuel Adeyemi</h4>
                <p className="winner-project">
                  "GIS-Based Healthcare Access Optimization for Underserved Communities"
                </p>
                <div className="winner-impact">
                  <Icon icon="mdi:check-circle" />
                  <span>Improved healthcare access for 50,000+ people</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="winner-card">
                <div className="winner-year">2022</div>
                <h4>Aisha Bello</h4>
                <p className="winner-project">
                  "Spatial Analysis of Water Quality and Disease Correlation"
                </p>
                <div className="winner-impact">
                  <Icon icon="mdi:check-circle" />
                  <span>Influenced water policy in 3 states</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

            {/* Application Form Modal */}
            {showApplicationForm && (
                <div className="application-modal">
                    <div className="modal-backdrop" onClick={() => setShowApplicationForm(false)}></div>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>RTYGIA Application Form</h3>
                            <button className="modal-close" onClick={() => setShowApplicationForm(false)}>
                                <Icon icon="mdi:close" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleApplicationSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Full Name *</label>
                                        <input type="text" className="form-control" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Email Address *</label>
                                        <input type="email" className="form-control" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Phone Number *</label>
                                        <input type="tel" className="form-control" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Age *</label>
                                        <input type="number" className="form-control" min="18" max="35" required />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Current Institution/Organization *</label>
                                        <input type="text" className="form-control" required />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Project Title *</label>
                                        <input type="text" className="form-control" required />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Project Summary (Max 500 words) *</label>
                                        <textarea className="form-control" rows="5" required></textarea>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Upload CV/Resume *</label>
                                        <input type="file" className="form-control" accept=".pdf,.doc,.docx" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Upload Project Proposal *</label>
                                        <input type="file" className="form-control" accept=".pdf,.doc,.docx" required />
                                    </div>
                                    <div className="col-12">
                                        <div className="form-check">
                                            <input type="checkbox" className="form-check-input" id="terms" required />
                                            <label className="form-check-label" htmlFor="terms">
                                                I agree to the terms and conditions and confirm all information is accurate
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-submit-application">
                                            <Icon icon="mdi:send" className="me-2" />
                                            Submit Application
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default RTYGIA;
